import { useEffect, useState } from "react";
import type { IngredientLots, IngredientLotsRepository } from "@/repositories";

export function useTrackIngredientLots(repository: IngredientLotsRepository): IngredientLots {
  const [lots, setLots] = useState<IngredientLots>({});

  useEffect(() => {
    return repository.trackLots(setLots);
  }, [repository]);

  return lots;
}
